import { render, staticRenderFns } from "./OtherPartyNotSpouseFaqDropdown.vue?vue&type=template&id=7c18831f"
import script from "./OtherPartyNotSpouseFaqDropdown.vue?vue&type=script&lang=ts"
export * from "./OtherPartyNotSpouseFaqDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports